<template>
  <svg
    class="stroke-current"
    viewBox="0 0 72 72"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      transform="translate(-11 -11)"
    >
      <path d="m0 0h94v94h-94z" />
      <g
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      >
        <path d="m58.75 82.25h-35.25c-6.4893458 0-11.75-5.2606542-11.75-11.75v-3.9166667h39.1666667v7.8333334c0 4.3262305 3.5071028 7.8333333 7.8333333 7.8333333s7.8333333-3.5071028 7.8333333-7.8333333v-54.8333334c0-4.3262305 3.5071028-7.8333333 7.8333334-7.8333333 4.3262305 0 7.8333333 3.5071028 7.8333333 7.8333333 0 4.3262306-3.5071028 7.8333334-7.8333333 7.8333334h-7.8333334m7.8333334-15.6666667h-43.0833334c-6.4893458 0-11.75 5.2606542-11.75 11.75v43.0833333" />
        <path d="m35.25 27.4166667h15.6666667" />
        <path d="m35.25 43.0833333h15.6666667" />
      </g>
    </g>
  </svg>
</template>
